// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
Widgets.Base = {

    parent: null,

    open_widgets: [],

    inherit: function(definition) {
        var new_self = $x.extend($x.object(this), definition);
        new_self.parent = this;
        return new_self;
    },

    create: function(options) {
        var self = $x.object(this);
        self.init(options);
        return self;
    },

    target_element: null,
    // the DOM element that will anchor where this widget appears
    init: function(options) {
        this.target_element = options.nextTo;
        //required for now -- eventually default to middle of screen
        var downOffset = options.down || 10;
        var alongOffset = options.along || 0;

        var targetOffset = $(this.target_element).offset();
        this.offset = {
            left: targetOffset.left + alongOffset,
            top: targetOffset.top + downOffset
        };
    },

    dom_element: null,
    j_element: null,
    // cached jQuery wrapper round dom_element
    definition: function() {
        return ['div.base-widget'];
    },

    build: function() {
        this.dom_element = JSML.transform(this.definition());
        this.j_element = $(this.dom_element);
        this.j_element.hide();
    },

    insert: function() {
        document.body.appendChild(this.dom_element);
    },

    remove: function() {
        var el = this.dom_element;

        if (el) {
          el.parentNode.removeChild(el);
        }
        else {
          $a.log('el wasn\'t defined');
        }
    },

    position: function() {
        if (this.target_element) {
            this.j_element.css({
                'position': 'absolute',
                'left': this.offset.left,
                'top': this.offset.top
            });
        }
    },

    show: function() {
        this.prepare();
        this.j_element.show();
        this.add_to_open_widgets();
    },

    fadeIn: function() {
        this.prepare();
        this.j_element.fadeIn();
        this.add_to_open_widgets();
    },

    hide: function() {
        $('#overlay_background').hide(); // @@ fixme
        this.j_element.hide();
        this.cleanup();
        this.remove_from_open_widgets();
        if ('function' === typeof this.after_hide_callback) {
            this.after_hide_callback();
        }
    },

    fadeOut: function() {
        var self = this;

        this.j_element.fadeOut(function () {
            self.cleanup();
            self.remove_from_open_widgets();
            if ('function' === typeof self.after_hide_callback) {
                self.after_hide_callback();
            }
        });
    },

    hide_all: function() {
        var open_widgets = Widgets.Base.open_widgets.slice();

        for (var i = 0; i < open_widgets.length; i++) {
            open_widgets[i].hide();
        }
    },

    add_to_open_widgets: function() {
        Widgets.Base.open_widgets.push(this);
    },

    remove_from_open_widgets: function() {
        var i = Widgets.Base.open_widgets.indexOf(this);
        if (i >= 0) {
            Widgets.Base.open_widgets.splice(i);
        }
    },

    prepare: function() {
        this.insert();
        this.position();
    },

    cleanup: function() {
        /* this is required for it to clean up properly in all versions of IE */
        this.j_element.html('');
        this.remove();
    },

    flash: function(callback, options) {
        if ('undefined' === typeof options) {
            options = {};
        }
        var fade_in_ms = options.fadeInMS || 100;
        var visible_ms = options.visibleMS || 400;
        var fade_out_ms = options.fadeOutMS || 400;

        var self = this;
        self.prepare();
        self.j_element.fadeIn(fade_in_ms,
        function() {
            setTimeout(function() {
                self.j_element.fadeOut(fade_out_ms,
                function() {
                    self.cleanup();
                    if (callback) {
                        callback();
                    }
                });
            },
            visible_ms);
        });
    },
};
